// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*\n.table-loc-reviews {\n    position: absolute;\n    margin-left: -100px;\n    margin-right: -100px;\n}*/\n", "",{"version":3,"sources":["webpack://src/games_store_parser/css/gamesStoreParser.css"],"names":[],"mappings":"AAAA;;;;;EAKE","sourcesContent":["/*\n.table-loc-reviews {\n    position: absolute;\n    margin-left: -100px;\n    margin-right: -100px;\n}*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
